import { GetPetProfile, Query } from '@wolfdanepug/common-react'
import { useLocation } from 'react-router'
import { useMemo } from 'react'
import { petProfileTabs } from '../../../constants'
import { useParams } from 'react-router'

export default function Page() {
	const { id, section } = useParams()
	const location = useLocation()

	const Component = useMemo(() => {
		const pathname = location.pathname
		const key = pathname.split('/').pop()
		const tab: any = petProfileTabs.find((tab: any) => tab.key === key)
		return tab.component
	}, [location.pathname])

	return (
		<Query
			doc={GetPetProfile}
			variables={{ id }}
			component={Component}
			getData={(data: any) => ({ data })}
			componentProps={{
				page: section
			}}
		/>
	)
}
